function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "1.-Rollover-Call-Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.2.-Rollover-Call-Dashboard",
  transform: "translate(-64.000000, -248.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(64.000000, 244.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "account_circle_black_24dp",
  transform: "translate(0.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 16 0 16 16 0 16"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,1.33333333 C4.32,1.33333333 1.33333333,4.32 1.33333333,8 C1.33333333,11.68 4.32,14.6666667 8,14.6666667 C11.68,14.6666667 14.6666667,11.68 14.6666667,8 C14.6666667,4.32 11.68,1.33333333 8,1.33333333 Z M4.71333333,12.1866667 C5,11.5866667 6.74666667,11 8,11 C9.25333333,11 11.0066667,11.5866667 11.2866667,12.1866667 C10.38,12.9066667 9.24,13.3333333 8,13.3333333 C6.76,13.3333333 5.62,12.9066667 4.71333333,12.1866667 Z M12.24,11.22 C11.2866667,10.06 8.97333333,9.66666667 8,9.66666667 C7.02666667,9.66666667 4.71333333,10.06 3.76,11.22 C3.08,10.3266667 2.66666667,9.21333333 2.66666667,8 C2.66666667,5.06 5.06,2.66666667 8,2.66666667 C10.94,2.66666667 13.3333333,5.06 13.3333333,8 C13.3333333,9.21333333 12.92,10.3266667 12.24,11.22 L12.24,11.22 Z M8,4 C6.70666667,4 5.66666667,5.04 5.66666667,6.33333333 C5.66666667,7.62666667 6.70666667,8.66666667 8,8.66666667 C9.29333333,8.66666667 10.3333333,7.62666667 10.3333333,6.33333333 C10.3333333,5.04 9.29333333,4 8,4 Z M8,7.33333333 C7.44666667,7.33333333 7,6.88666667 7,6.33333333 C7,5.78 7.44666667,5.33333333 8,5.33333333 C8.55333333,5.33333333 9,5.78 9,6.33333333 C9,6.88666667 8.55333333,7.33333333 8,7.33333333 Z",
  id: "Shape",
  fill: "#0AA6A8",
  fillRule: "nonzero"
})))));

function SvgAccountCircleBlack24Dp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "827ED4B3-0E50-469E-BB7F-7D0477E84E63@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircleBlack24Dp);
export default __webpack_public_path__ + "static/media/account_circle_black_24dp.9039399c.svg";
export { ForwardRef as ReactComponent };